import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 44 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const ChapterHeading = ({ number, label, testId }) => (
  <Reveal className="mb-14 md:mb-20">
    <div className="flex items-baseline gap-5" data-testid={testId}>
      <span className="font-serif text-sm tracking-[0.35em] text-[#C5A059]">
        {number}
      </span>
      <span className="text-xs font-medium uppercase tracking-[0.35em] text-[#A1A1AA]">
        {label}
      </span>
    </div>
    <div className="chapter-rule mt-6 w-full" />
  </Reveal>
);
